import * as React from 'react';
import { getUserColor } from './Data/Data';
import { Container, Text } from './style/Style';
import { useRecoilValue } from 'recoil';
import { AProfile, AUsers } from '../../atoms/global/users';
import Doodle, { DoodleConfig } from '../../styles/custom-icons/doodles/doodle';

function Avatar(props: {
	width: string
	name: string
	userId?: number
	fontSize?: string
	backgroundColor?: string
	isYou?: boolean
}): JSX.Element {
	const newName = props.name?.trim().split(' ', 2).map(c => c.charAt(0) ?? '').join('').toUpperCase() ?? '';
	const users = useRecoilValue(AUsers);
	const profile = useRecoilValue(AProfile);
	const picture = users.find(c => c.id === props.userId || (props.isYou && c.isYou))?.photoUrl;
	let doodleConfig: DoodleConfig | undefined;
	let color: string | undefined;
	if (props.isYou) {
		color = profile.color;
		doodleConfig = profile.doodle_configuration;
	}
	else if (props.userId) {
		const user = users.find(c => c.id === props.userId);
		color = user?.color;
		doodleConfig = user?.doodle_configuration;
	}

	if (props.backgroundColor) color = props.backgroundColor;
	else if (!color) color = getUserColor(props.name);

	return <Container style={{ overflow: 'hidden' }} width={props.width} height={props.width} backgroundColor={color}>
		{picture
			? <img src={picture} style={{ borderRadius: '50%' }} height={props.width} width={props.width} />
			: doodleConfig
				? <Doodle size={`calc(${props.width} * 2)`} style={{ left: '10%', top: '10%' }} config={doodleConfig} />
				: <Text fontSize={props.fontSize} name={newName}>{newName}</Text>
		}
	</Container>;
}

export default Avatar;
